/** 版（エディション）。ビルド時の `VITE_EDITION` で決まる（ADR-0002）。 */
export type EditionKey = 'online' | 'offline';

export interface Edition {
  key: EditionKey;
  /** 利用者向けの名称。 */
  name: string;
  /** ヘッダーの札に出す短い名前。 */
  tag: string;
}

export const EDITIONS: Readonly<Record<EditionKey, Edition>> = {
  online: { key: 'online', name: '3D現場ポータル Google 3D版', tag: 'Google 3D版' },
  offline: { key: 'offline', name: '3D現場ポータル オフライン版', tag: 'オフライン版' },
};

/** 環境変数の値から版を決める。未設定は online。知らない値は誤りとして止める。 */
export function resolveEdition(value: string | undefined): Edition {
  if (value === undefined || value === '') return EDITIONS.online;
  if (value === 'online' || value === 'offline') return EDITIONS[value];
  throw new Error(`VITE_EDITION は online か offline: ${value}`);
}
